/* eslint-disable no-tabs */
import logo from '@src/assets/images/logo/rfc-logo.svg'

const Footer = () => {
	return (

		<div className="clearfix mb-0">
			<div className="d-flex justify-content-center col-12 text-center">
				<a href="https://www.rugfreecoins.com/" target="_blank" >
					<span className="float-md-start d-block d-md-inline-block mt-25">
						<b>Developed By </b>
						<img className="fallback-logo" src={logo} alt="logo" height={'30px'} />
						<b> RugfreeCoins</b>
					</span>
				</a>
			</div>
		</div>

	)
}

export default Footer
